import { hasDiagramDarkMode } from '@y42/gojs';
import { JobStatusToIcon, noJobIcon, noJobIconDark } from '@y42/job';
import { JobStatus } from '@y42/json-schema';
import { Binding, GraphObject, Margin, Part, Picture, Size } from 'gojs';
import { DataLineageNodeBinding, LINEAGE_PARTS } from '../../../../../../state/data-lineage-diagram';
import { nodeStatusTooltip } from './tooltips';

const $ = GraphObject.make;

export const dataLineageNodeStatus = (bindings: Binding[] = []) =>
  $(
    Picture,
    {
      name: LINEAGE_PARTS.NODE_STATUS,
      desiredSize: new Size(18, 18),
      imageStretch: GraphObject.Uniform,
      margin: new Margin(0, 5),
      toolTip: nodeStatusTooltip(),
    },
    iconBinding(),
    ...bindings,
  );

const iconBinding = () =>
  new Binding('source', DataLineageNodeBinding.Status, (status: JobStatus | null, part: Part) => {
    const hasDarkMode = hasDiagramDarkMode(part.diagram);

    if (!status) {
      return hasDarkMode ? noJobIconDark : noJobIcon;
    }
    return hasDarkMode && JobStatusToIcon[status].iconDark
      ? JobStatusToIcon[status].iconDark
      : JobStatusToIcon[status].icon;
  });
